<template>
    <el-form :model="form" :rules="rules" :ref="bindRef" class="clearfix">
      <el-row :gutter="20">
        <template v-for="(item,index) in column" >
          <el-col :span="item.span?item.span:12" class="col">
            <template v-if="item.tips">
                <el-tooltip class="tips" :content="item.tips" placement="right">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            <el-form-item :class="item.formHide?'dn':''"  :key="index" :label="item.label" :prop="item.field" v-show="item.advanceSearch!==false">
              <template v-if="item.type==='selectTree'">
                <lr-select-tree
                  :props="item.props"
                  :options="item.options"
                  :value="form[item.field]?form[item.field]:item.default"
                  :field="item.field"
                  @getValue="getValue"
                  :disabled="item.disabled"
                  :readonly="item.readonly"
                  :itemOptions="item"
                />
              </template>
              <template v-else>
                <lr-input  :itemOptions="item"  @handleInput="handleInput" v-model="form[item.field]">
                  <!-- <template v-if="item.slot&&item.type=='icon'" #append>
                    <slot :name="item.field"></slot>
                  </template>
                  <template v-else-if="item.type=='icon'" #append>
                      <span class="iconSpan">
                        <el-button :icon="form[item.field]?form[item.field]:item.default"></el-button>
                        <el-popover
                          placement="top"
                          width="160"
                          v-model="true">
                        </el-popover>
                      </span>
                      <el-button icon="el-icon-caret-bottom"></el-button>
                  </template> -->
                </lr-input>
              </template>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
</template>

<script>
export default {
  name: "lrForm",
  props:{
    form:{
      type:Object,
      default:()=>{},
    },
    column:{
      type: Array,
      default:()=>[],
    },
    bindRef:{
      type: String,
      default:'form',
    },
    rules:{
      type:Object,
      default:()=>{},
    },
    closeDestroy:{
      type:Boolean,
      default:true,
    },
  },
  data() {
    return {
    };
  },
  computed:{
  },
  watch:{
     form: {
      handler: function (n, o) {
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$refs[this.bindRef].resetFields()
  },
  methods: {
    handleInput(value,field) {
      this.$set(this.form,field,value)
    },
    getValue(value,field) {
      this.$set(this.form,field,value)
      //this.form[field] = value;
    },
    validate(callBack){
      this.$refs[this.bindRef].validate((valid) => {
          callBack(valid)
      });
    }
  },
  beforeDestroy(){
    if(this.closeDestroy){
      this.$refs[this.bindRef].resetFields()
    }
  }
};
</script>

<style scoped  lang="scss">
.dn{
  display: none!important;
}
  >>> .el-form-item--small .el-form-item__content>span{
    display: inline-block;
    line-height: 33px;
    width: 100%;
}
>>>.el-form-item{
  display: flex;
  margin-bottom: 25px;
  .el-form-item__error{
    padding-top:4px;
  }
  .el-form-item__label{
    font-weight:400;
    flex: 0 0 100px;
    margin-right:10px
  }
  .el-form-item__content {
      width:100%;
      height:33px;
  }

  .el-input{
    width:100%
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner,.el-select{
    width:100%;
  }
} 
 .tips{
   position: absolute;
    left: 101px;
    color: #ff6f6f;
    top: 9px;
    font-size: 16px;
  }
  .col{
    position: relative;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/LrForm/index.vue